export class MenuItem {
    level: number;
    url: string;
    name: string;
    descrip: string;
    title: string;
    route: string;
}

export class Menu {
    label: string;
    url: string;
    title: string;
    menuItems: MenuItem[];
    expand: boolean;
}